import { render, staticRenderFns } from "./QuotationRiskItemAgricola.vue?vue&type=template&id=dd9d04c2"
import script from "./QuotationRiskItemAgricola.vue?vue&type=script&lang=js"
export * from "./QuotationRiskItemAgricola.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports